import React from 'react';
import { Scissors, Leaf, TreePine, Sparkles, Phone } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';

const ServicesSection = () => {
  const services = [
    {
      icon: Scissors,
      title: 'Lawn Mowing',
      description: 'Professional lawn mowing service for residential properties. We keep your grass looking neat and healthy all year round.',
      features: ['Regular mowing schedules', 'Edge trimming included', 'Grass clipping removal']
    },
    {
      icon: Leaf,
      title: 'Garden Maintenance',
      description: 'Complete garden care to keep your outdoor space beautiful and well-maintained throughout the seasons.',
      features: ['Weeding & pruning', 'Hedge trimming', 'Garden bed care']
    },
    {
      icon: TreePine,
      title: 'Lawn Edging',
      description: 'Precise edging services to give your lawn clean, defined borders and a professionally finished appearance.',
      features: ['Pathway edging', 'Garden bed borders', 'Driveway edges']
    },
    {
      icon: Sparkles,
      title: 'Property Tidy Up',
      description: 'Complete yard clean-up services including leaf removal, debris clearing, and general property maintenance.',
      features: ['Leaf removal', 'Debris clearing', 'Green waste disposal']
    }
  ];

  return (
    <section id="services" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Our <span className="text-green-600">Services</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Professional lawn mowing and garden maintenance services for residential properties across Melbourne's southeast.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <Card key={index} className="border-2 border-gray-100 hover:border-green-200 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
                <CardContent className="p-8">
                  <div className="flex items-start gap-4">
                    <div className="w-14 h-14 bg-green-100 rounded-xl flex items-center justify-center flex-shrink-0">
                      <Icon className="h-7 w-7 text-green-600" />
                    </div>
                    <div className="flex-1">
                      <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
                      <p className="text-gray-600 mb-4">{service.description}</p>
                      <ul className="space-y-2">
                        {service.features.map((feature, idx) => (
                          <li key={idx} className="flex items-center text-sm text-gray-700">
                            <div className="w-1.5 h-1.5 bg-green-600 rounded-full mr-2"></div>
                            {feature}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* CTA */}
        <div className="text-center bg-gradient-to-r from-green-50 to-green-100 rounded-2xl p-8 sm:p-12">
          <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4">
            Ready to Get Your Lawn Looking Great?
          </h3>
          <p className="text-gray-600 mb-6 max-w-xl mx-auto">
            Contact us today for a fast quote. We're here to help with all your lawn care needs.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a href="tel:0434600945">
              <Button className="bg-green-600 hover:bg-green-700 text-white px-8 py-6 text-lg font-semibold rounded-xl flex items-center gap-3 shadow-lg hover:shadow-xl transition-all">
                <Phone className="h-5 w-5" />
                Get a Fast Quote
              </Button>
            </a>
            <a href="sms:0434600945">
              <Button className="bg-white hover:bg-gray-50 text-green-600 border-2 border-green-600 px-8 py-6 text-lg font-semibold rounded-xl flex items-center gap-3 shadow-lg hover:shadow-xl transition-all">
                Message Mini Mike
              </Button>
            </a>
          </div>
          <p className="text-sm text-gray-500 mt-4">Local & reliable • Fast response</p>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
